import { PostNavigationProps } from "@/types/layout";
import React, { useEffect, useState } from "react";
import { PostNavigationBookmarkButton } from "@/components/modules/Post/PostNavigationBookmarkButton";
import { PostNavigationDownloadButton } from "@/components/modules/Post/PostNavigationDownloadButton";
import { PostNavigationSocialsButton } from "@/components/modules/Post/PostNavigationSocialsButton";
import { useOfflinePostContent } from "@/hooks/indexeddb/useOfflinePostContent";
import { PostNavigationUnlockButton } from "@/components/modules/Post/PostNavigationUnlockButton";

export const PostNavigation: React.FC<PostNavigationProps> = ({ post }) => {
  const [isTrackDownloaded, setIsTrackDownloaded] = useState<boolean>(false);
  const { saveOrDelete, downloading, isDownloaded } = useOfflinePostContent();
  const [showUnlockButton, setShowUnlockButton] = useState(false);

  useEffect(() => {
    if (post?.id) {
      isDownloaded(post?.id).then((res) => {
        setIsTrackDownloaded(res);
      });
    }
    if (post?.paywallEnabled) {
      setShowUnlockButton(true);
    }
  }, [post, isDownloaded]);

  return (
    <div className="bg-white dark:bg-dark">
      <ul className="flex items-center justify-between text-center font-sans text-sm lg:justify-end">
        <PostNavigationSocialsButton post={post} />
        {showUnlockButton && <PostNavigationUnlockButton title={post?.title} />}
        <PostNavigationBookmarkButton postTitle={post?.title} postId={post?.id!} />
        <PostNavigationDownloadButton
          onClick={() => saveOrDelete(post!)}
          downloaded={isTrackDownloaded}
          downloading={downloading}
          postTitle={post?.title}
          mediaURL={post?.audio?.url}
        />
      </ul>
    </div>
  );
};
